import React from 'react';
import * as Yup from 'yup';
import { Avatar } from '@material-ui/core';
import language from '../languages';
import {firestore} from "../firebase";
import buildQuery from "./EntityUtil";

const meta = (lang) => { 
    return {
        entityName: language[lang].Setting,
        emptyRow: () => {
            return {
                dataType: 'string',
                description: '',
                input: 'text',
                label: '',
                value: '',
                getItems: [],
            }
        },
        collection: 'configs',
        addButtonText: language[lang].New_Setting,
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        hideTitle: true,
        settingsFields: true,
        fields: [
            {name: 'label', default: null, dataType: 'string', label: 'Name', input: 'text'},
            {name: 'value', default: null, dataType: 'string', label: 'Value', input: 'text'},
            {name: 'input', default: null, dataType: 'string', label: 'Input', input: 'text'},
            {name: 'required', default: null, dataType: 'boolean', label: 'Required', input: 'text'},
            {name: 'dataType', default: null, dataType: 'string', label: 'Data Type', input: 'text'},
            {name: 'description', default: null, dataType: 'string', label: 'Description', input: 'text'},
            {name: 'order', default: null, dataType: 'number', label: 'Input', input: 'text'},
            {name: 'getItems', default: null, dataType: 'array', label: 'Get Items', input: 'select'},
        ],
        table: [
            {name: 'label', type: 'field', label: 'Name'},
            {name: 'value', type: 'field', label: 'Value',
                render: (doc)=> {
                    if(doc.input == 'file')
                        return <img src={doc.value} alt={doc.label} style={{ height: '40px' }} />
                    else
                        return doc.value
                }
            },
            {name: 'actions', type: 'action', label:'Actions', actions: ['edit']}
        ],
        getValidationSchema : (doc) => {
            if(doc.required){
                return Yup.object({
                        value: Yup.string()
                            .required(language[lang].Field_Required),
                    })
            }
            return Yup.object({})
        },
        // validationSchema: Yup.object({
        //     label: Yup.string()
        //         .required(language[lang].Field_Required),
        //     value: Yup.string()
        //         .required(language[lang].Field_Required),
        // }),
        filterObject: [],
        defaultOrderBy: ['order', 'asc'],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('configs');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        beforeSave: (user, doc)=> {
            return doc
        }
    }
}

export default meta;